import { forwardRef, useState } from "react";
import { useTranslation } from "@vixi/localization";
import { STEP_TYPE } from "@vixi/types";
import { CourseTabGroup } from "@vixi/types";
import { courseTabsClasses } from "@/classes/courseTabsClasses";
import { emptyStep } from "@vixi/utils";
import { ButtonProps, Button } from "@/components/base/button";
import {
  ActionMenuContent,
  ActionMenuItem,
  DropdownMenu,
  DropdownMenuTrigger,
} from "@/components/base/dropdown-menu";
import { cn } from "@/lib";

const AddStepsButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => (
    <Button
      {...props}
      className={cn(courseTabsClasses.addItemButton, "fs-14 mt-auto w-fit self-center", className)}
      ref={ref}
      variant="outlined"
      size="pill"
      content=""
    />
  ),
);

interface AddStepMenuProps {
  tabList: CourseTabGroup;
  addItem: (item?: unknown) => void;
}

export const AddStepMenu = (props: AddStepMenuProps) => {
  const { t, tDeep } = useTranslation();
  const [open, setOpen] = useState(false);

  const addStep = (stepType: STEP_TYPE) => {
    const nextId = Math.max(...props.tabList.tabs.map((item) => item.id)) + 1;
    props.addItem(tDeep(emptyStep(stepType, nextId)));

    setOpen(false);
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <AddStepsButton>{t("Course.AddStep")}</AddStepsButton>
      </DropdownMenuTrigger>

      <ActionMenuContent>
        <ActionMenuItem>
          <button onClick={() => addStep(STEP_TYPE.CONVERSATION)}>
            {t("Course.Conversation")}
          </button>
        </ActionMenuItem>

        <ActionMenuItem>
          <button onClick={() => addStep(STEP_TYPE.MCQ)}>{t("Question.Mcq")}</button>
        </ActionMenuItem>

        <ActionMenuItem>
          <button onClick={() => addStep(STEP_TYPE.FITB)}>{t("Question.FillBlank")}</button>
        </ActionMenuItem>

        <ActionMenuItem>
          <button onClick={() => addStep(STEP_TYPE.MATCHING)}>{t("Question.Matching")}</button>
        </ActionMenuItem>
      </ActionMenuContent>
    </DropdownMenu>
  );
};
